// Mantido para retirar instalações antigas, sem registrar novos workers.
export async function unregister(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;

  try {
    const scriptUrl = new URL(`${process.env.PUBLIC_URL || ''}/service-worker.js`, window.location.href);
    if (scriptUrl.origin !== window.location.origin) return;
    const scope = new URL('./', scriptUrl).href;

    // ready pode nunca resolver quando não existe um worker ativo.
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(async registration => {
      if (registration.scope !== scope) return;
      const workers = [registration.active, registration.waiting, registration.installing].filter(Boolean);
      if (!workers.length || !workers.every(worker => {
        const url = new URL(worker!.scriptURL);
        return url.origin === scriptUrl.origin && url.pathname === scriptUrl.pathname;
      })) return;

      // Não apaga armazenamento nem recarrega um checkout em andamento.
      await registration.unregister();
    }));
  } catch (error) {
    // A indisponibilidade desta API não pode impedir o atendimento online.
    console.warn('Não foi possível retirar o service worker antigo do cardápio.', error);
  }
}
